import { render, staticRenderFns } from "./booksonly.vue?vue&type=template&id=18ef1204&scoped=true&"
import script from "./booksonly.vue?vue&type=script&lang=js&"
export * from "./booksonly.vue?vue&type=script&lang=js&"
import style0 from "./booksonly.vue?vue&type=style&index=0&id=18ef1204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef1204",
  null
  
)

export default component.exports